<template>
    <div id="app" class="avp-app container">
        <div class="avp-app-wrapper row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 avp-app-content" :class="containerClass">
                <div class="card">
                    <div class="card-header avp-card-header">
                        <CardHeader :variant="variant" />
                    </div>

                    <div class="card-body routes-wrapper">
                        <ErrorMessages />

                        <Loading v-if="loading" />

                        <SmoothReflow>
                            <router-view class="card-body-content"></router-view>
                        </SmoothReflow>
                    </div>

                    <div class="card-footer avp-card-footer">
                        <CardFooter/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import CardHeader from './components/CardHeader';
    import CardFooter from './components/CardFooter';
    import ErrorMessages from '@/components/ErrorMessages'
    import Loading from '@/components/Loading';
    import localizable from '@/mixins/localizable';
    import variations from '@/mixins/variations';
    import tracking from '@/mixins/tracking';
    import stateToRoute from '@/mixins/stateToRoute';
    import SmoothReflow from '@/components/SmoothReflow';
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'app',
        components: {
            ErrorMessages,
            CardHeader,
            CardFooter,
            Loading,
            SmoothReflow
        },
        mixins: [localizable, variations, stateToRoute, tracking],
        computed: {
            ...mapState(['loading', 'success', 'proceedToBooking']),
            ...mapGetters(['isBooking', 'isPrivilegedClient']),
            containerClass() {
                if (this.isBooking && !this.success && this.proceedToBooking) {
                    return "col-xl-8 " + this.variant.key;
                }
                return "col-xl-8 " + this.variant.key;
            }
        },
        created() {
            console.log("App.created()");
            this.$store.dispatch('setup');
        }
    };
</script>

<style lang="scss" scoped>
@use "@/styles/_variables";
@use "sass:map";

    .avp-app {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .avp-app-wrapper {
            justify-content: center;
            min-height: 100%;
        }

        .avp-app-content {
            .card {
                background-color: rgba(#fff, 0.85);
                border: none;
                border-radius: 0;
                box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
                margin-top: 1.25rem;
                margin-bottom: 1.25rem;

                .card-header {
                    background: rgba(#fff, 0.5);
                    border-radius: inherit;
                }

                .card-body {
                    padding: variables.$padding;
                    position: relative;

                    & ::v-deep {
                        background: rgba(#fff, 0.5);
                        height: auto;

                        .card-title {
                            color: map.get(variables.$colors, 'header');
                            font-weight: 500;
                        }

                        .card-navigation {
                            display: flex;
                            justify-content: center;
                            align-items: flex-start;

                            &:not(:last-child) {
                                padding-bottom: 1.25rem;
                            }
                        }
                    }
                }

                .card-footer {
                    background-color: rgba(map.get(variables.$colors, 'footer-bg'), 0.75);
                    border-radius: inherit;
                }

            }

        }
    }
</style>

